module.exports = __webpack_public_path__ + "img/logo.42ef37d4.png";